import { type MetaFunction, useLoaderData } from "@remix-run/react";
import Container from "~/components/layout/Container";
import { buildMeta } from "~/lib/seo";
import { slugify } from "~/lib/slugify";
import { references } from "../_index";
import References from "../features/References";
import ServicesComponent from "../features/Services";
import { HizmetListesi } from "../hizmetlerimiz+/_index";

export const blogPosts = [
  {
    id: 1,
    title: "En uygun ısıtma sistemleri nasıl seçilir?",
    excerpt: `
      
    <div>
    <h2>En Uygun Isıtma Sistemleri Nasıl Seçilir?  </h2>

    <p>Kış aylarının soğuğunu atlatmak için evinizde veya iş yerinizde doğru ısıtma sistemi seçmek, hem konforunuzu hem de bütçenizi doğrudan etkiler. Peki, en uygun ısıtma sistemini nasıl seçersiniz? İşte size adım adım rehber!</p>
    <h3>1. Mekanın Özelliklerini Değerlendirin</h3>  

    <p>Isıtma sistemi seçimi, mekanın büyüklüğüne, izolasyonuna ve kullanım amacına bağlıdır. Aşağıdaki faktörleri göz önünde bulundurun:</p>

    <ul>
      <li><strong>Mekanın Büyüklüğü:</strong> </li>
      <li>Küçük bir daire mi yoksa geniş bir fabrika mı ısıtmak istiyorsunuz? Küçük mekanlar için elektrikli radyatörler veya tüplü kombi ideal iken, büyük alanlar için merkezi ısıtma veya radyant ısıtıcılar daha uygundur.</li> 
  
      <li><strong>Yapı İzolasyonu:</strong> </li>
      <li>İyi izole edilmiş binalar, ısı kaybını azaltır ve enerji tasarrufu sağlar. İzolasyonun zayıf olduğu durumlarda, verimli bir ısıtma sistemi tercih etmek önemlidir.</li> 
  
      <li><strong>Tavan Yüksekliği:</strong> </li>
      <li>Yüksek tavanlı mekanlar için radyant ısıtıcılar veya sıcak hava üreteçleri daha etkilidir. Düşük tavanlı mekanlarda ise yerden ısıtma veya fancoil sistemleri idealdir.</li> 
    </ul>
     

    <h3>2. Enerji Kaynağını Belirleyin</h3>  

    <p>Isıtma sisteminizin çalışacağı enerji kaynağı, maliyet ve çevre dostu olma açısından büyük önem taşır. En yaygın enerji kaynakları şunlardır:</p>

    <ul>
      <li><strong>Doğalgaz:</strong> </li>
      <li>Doğalgaz, düşük işletme maliyeti ve çevreye zarar vermeyen özellikleriyle en popüler seçenektir. Ancak, doğalgaz şebekesine bağlı olmanız gerekir.</li> 
  
      <li><strong>Elektrik:</strong> </li>
      <li>Elektrikli sistemler (elektrikli radyatörler, yerden ısıtma vb.) hızlı ısınma sağlar ancak elektrik maliyeti yüksek olan bölgelerde uzun vadede pahalı olabilir.</li> 
  
      <li><strong>LPG veya Tüp Gaz:</strong> </li>
      <li>Doğalgaz altyapısının olmadığı bölgelerde idealdir. Ancak, gaz tüplerinin düzenli olarak yenilenmesi gereklidir.</li> 
  
      <li><strong>Katı Yakıtlar (Odun, Kömür, Pellet):</strong> </li>
      <li>Ekonomik ve çevre dostu seçenekler arasındadır. Özellikle kırsal alanlar veya alternatif enerji kaynaklarına ihtiyaç duyulan yerlerde tercih edilir.</li> 
  
      <li><strong>Yenilenebilir Enerji (Güneş Enerjisi, Jeotermal):</strong> </li>
      <li>Çevre dostu ve uzun vadede maliyeti düşüren seçeneklerdir. Ancak ilk yatırım maliyeti yüksektir.</li> 
    </ul>
     

    <h3>3. Kullanım Amacınıza Göre Seçim Yapın</h3>  

    <p>Isıtma sistemi, kullanım amacınıza göre değişiklik gösterebilir:</p>

    <ul>
      <li><strong>Konutlar İçin:</strong> </li>
      <li>Merkezi ısıtma (doğalgaz), yerden ısıtma veya kombi sistemleri idealdir. Küçük mekanlar için elektrikli radyatörler veya tüplü kombi de kullanılabilir.</li> 
  
      <li><strong>Endüstriyel Alanlar İçin:</strong> </li>
      <li>Sıcak hava üreteçleri, radyant ısıtıcılar veya katı yakıtlı kazanlar tercih edilebilir. Geniş alanlar için verimli ve güçlü sistemler gereklidir.</li> 
  
      <li><strong>Açık Alanlar İçin:</strong> </li>
      <li>Radyant ısıtıcılar veya mobil sıcak hava üreteçleri, açık hava etkinlikleri veya inşaat alanları için mükemmeldir.</li> 
    </ul>
     

    <h3>4. Bütçenizi Belirleyin</h3>  

    <p>Isıtma sistemi seçerken, hem ilk yatırım maliyetini hem de uzlongvade işletme maliyetini göz önünde bulundurun:</p>

    <ul>
      <li><strong>İlk Yatırım Maliyeti:</strong> </li>
      <li>Yerden ısıtma veya merkezi ısıtma gibi sistemlerin kurulum maliyeti yüksektir. Ancak uzun vadede enerji tasarrufu sağlar.</li> 
  
      <li><strong>İşletme Maliyeti:</strong> </li>
      <li>Doğalgaz ve LPG gibi yakıtların maliyeti bölgesel olarak değişir. Elektrikli sistemlerin enerji tüketimini hesaplamak önemlidir.</li> 
  
      <li><strong>Bakım Maliyeti:</strong> </li>
      <li>Bazı sistemler (örneğin katı yakıtlı kazanlar) düzenli bakım gerektirir. Bakım maliyetini bütçenize dahil edin.</li> 
    </ul>
     

    <h3>5. Verimlilik ve Enerji Tasarrufunu Öncelikli Tutun</h3>  

    <p>Enerji verimliliği, hem çevreye katkıda bulunur hem de faturalarınızı düşürür. Aşağıdaki noktalara dikkat edin:</p>

    <ul>
      <li><strong>Yüksek Verimlilikli Cihazlar:</strong> </li>
      <li>Modern teknolojiye sahip cihazlar, enerji tüketimini minimize eder.</li> 
  
      <li><strong>Akıllı Termostatlar:</strong> </li>
      <li>Odalara özel sıcaklık ayarı yaparak enerji tasarrufu sağlar.</li> 
  
      <li><strong>Yenilenebilir Enerji Entegrasyonu:</strong> </li>
      <li>Güneş enerjisi veya jeotermal enerji ile çalışan sistemler, uzun vadede tasarruf sağlar.</li> 
    </ul>
     

    <h3>6. Çevre Dostu Seçenekleri Tercih Edin</h3>  

    <p>Çevreye duyarlı bir yaşam tarzı benimsemek istiyorsanız, çevre dostu ısıtma sistemlerini tercih edin:</p>

    <ul>
      <li><strong>Biokütle Yakıtlar (Pellet):</strong> </li>
      <li>Çevreye zarar vermez ve sürdürülebilir bir seçenektir.</li> 
  
      <li><strong>Güneş Enerjisi:</strong> </li>
      <li>Sıcak su ve ısıtma ihtiyacını karşılar. İlk yatırım maliyeti yüksek olsa da uzun vadede karlıdır.</li> 
  
      <li><strong>Düşük Karbon Emisyonlu Sistemler:</strong> </li>
      <li>Doğalgaz veya LPG kullanan sistemler, çevreye zararlı emisyon salınımını azaltır.</li> 
    </ul>
     

    <h3>7. Profesyonel Danışmanlık Alın</h3>  

    <p>Isıtma sistemi seçimi, karmaşık bir süreç olabilir. Profesyonel bir firmanın danışmanlığıyla:</p>

    <ul>
      <li>Mekanınız için en uygun sistem belirlenebilir.</li>
      <li>Kurulum süreci sorunsuz bir şekilde tamamlanabilir.</li>
      <li>Düzenli bakım ve destek hizmetleri alınabilir.</li>
    </ul>
     

    <h3>Sonuç: İhtiyaçlarınıza Özel Bir Çözüm Bulun</h3>  

    <p>En uygun ısıtma sistemi seçmek için, mekanınızın özelliklerini, enerji kaynağını, kullanım amacınızı ve bütçenizi dikkate almanız gerekir. Ayrıca, enerji verimliliği ve çevre dostu seçenekler de tercihlerinizde önemli bir rol oynar. AL-DE Mühendislik  olarak, ısıtma sistemlerinde uzmanlaşmış ekibimizle size danışmanlık, tasarım, kurulum ve bakım hizmetleri sunuyoruz. </p>

    <p>Konforlu ve sürdürülebilir bir yaşam için – AL-DE Mühendislik ile!</p>
    </div>
    `,
    date: "2023-05-15",
    image: "/assets/en-iyi-isitma-sistemi.webp",
  },
  {
    id: 2,
    title: "Yerden ısıtma nedir?",
    excerpt: `
      <div>
    <h3>Yerden Isıtma Tesisatı Nedir?  </h3>

<p>Yerden ısıtma tesisatı , mekanların zemininden ısı yayarak eşsiz bir konfor sağlayan modern bir ısıtma sistemidir. Geleneksel radyatörlerin aksine, bu sistem ısıyı doğrudan zeminden odaya homojen bir şekilde dağıtır. Böylece, başta sıcak – ayakta soğuk hissi ortadan kalkar ve mekan içinde dengeli bir sıcaklık deneyimi yaşarsınız. </p>

<h4>Bu sistem, hidronik (sulu)  veya elektrikli  olmak üzere iki temel prensiple çalışır:   </h4>

    <ul>
      <li><strong>Hidronik Sistemler:</strong>  Kazan veya ısı pompası ile ısıtılan su, zemin altına yerleştirilen borularda dolaşır.  </li>
      <li><strong>Elektrikli Sistemler:</strong>  Zemine monte edilen elektrikli ısıtıcı kablolar veya paspaslar aracılığıyla ısı sağlanır.</li>
    </ul>
     

<p>Yerden ısıtma tesisatı, özellikle enerji verimliliği, estetik tasarım ve sağlığa duyarlı ısıtma çözümleri sunar. Radyatör gibi görsel engeller içermediği için iç mekan tasarımı üzerinde sınırsız özgürlük tanır. Ayrıca, düşük sıcaklıkla çalıştığı için enerji tüketimini minimize eder ve çevreye olan etkisini azaltır. </p>
<h3>Neden Yerden Isıtma Tesisatı?  </h3>

    <ul>
      <li><strong>Enerji Tasarrufu:</strong>  Düşük su sıcaklıkları ile çalıştığı için %20-30’a varan enerji tasarrufu sağlar.  </li>
      <li><strong>Sağlıklı Ortam:</strong>  Hava sirkülasyonu yerine ışıma ile ısıtma yaptığı için toz, alerjen ve nem sorunlarını azaltır.  </li>
      <li><strong>Estetik Tasarım:</strong>  Radyatör veya diğer ısıtma elemanlarının bulunmaması, mekanlara ferah bir görünüm kazandırır.  </li>
      <li><strong>Sessiz Çalışma:</strong>  Fan veya motor içermediği için sessiz bir ortam sağlar.  </li>
      <li><strong>Uzun Ömürlü:</strong>  Kaliteli malzemelerle kurulan sistemler, 50+ yıl sorunsuz çalışabilir.</li>
    </ul>
     

<h4>Yerden Isıtma Tesisatının Çalışma Prensibi  </h4>

<p>
  Yerden ısıtma sistemi, zemin altına döşenen özel ısıtma boruları veya kablolar aracılığıyla çalışır. Bu bileşenler, kazan veya ısı pompasından gelen sıcak suyu veya elektrik enerjisini kullanarak zemini ısıtır. Isı, zeminden başlayarak yukarı doğru yayılır ve odanın her köşesinde eşit bir sıcaklık sağlar. Akıllı termostatlar ile kontrol edilen sistem, kullanıcıların ihtiyaçlarına göre programlanabilir ve enerji tüketimini optimize eder. 
  Profesyonel Çözümlerle Yerden Isıtma Tesisatı 
</p> 

Yerden ısıtma tesisatının kurulumu, uzmanlık gerektiren bir süreçtir. Doğru tasarım, kaliteli malzemeler ve profesyonel ekip, sistemin verimli ve uzun ömürlü olmasını sağlar. <b>AL-DE Mühendislik</b>  olarak, yerden ısıtma tesisatı projelerinizde size danışmanlık, tasarım, kurulum ve bakım hizmetleri sunuyoruz. Modern teknoloji ve müşteri odaklı yaklaşımımızla, konforlu ve sürdürülebilir bir yaşam alanı yaratmanıza yardımcı oluyoruz. 
       
    </div>
    `,
    date: "2023-05-15",
    image: "/assets/yerden-isitma.jpg",
  },
  {
    id: 3,
    title: "Yerden ısıtma sistemlerinin avantajları nelerdir?",
    excerpt: `
      <div>
     <h3>Yerden ısıtma sistemlerinin avantajları nelerdir?</h3>
        <ul>
            <li><strong>Homojen Isı Dağılımı:</strong> Isı, zeminden başlayarak odaya dengeli yayılır. Başta sıcak – ayakta soğuk hissinin önüne geçer.</li>
            <li><strong>Enerji Verimliliği:</strong> Düşük su sıcaklıkları ile çalışarak %20-30’a varan enerji tasarrufu sağlar.</li>
            <li><strong>Estetik Tasarım:</strong> Radyatör veya boruların görünmez olması, iç mekan tasarımında sınırsız özgürlük sunar.</li>
            <li><strong>Sağlık Dostu:</strong> Hava sirkülasyonu yerine ışıma ile ısıtma yaptığı için toz ve alerjenlerin havalandırılmasına katkıda bulunur.</li>
        </ul>
        <h4>Sistem Bileşenleri</h4>
        <ul class="components-list">
            <li><strong>Isıtma Boruları/Kabloları:</strong> Dayanıklı polietilen (PEX) veya paslanmaz çelik malzemeler kullanılır.</li>
            <li><strong>Kollektör ve Vana Grubu:</strong> Sıcaklık dağılımını dengeleyen kontrol ünitesi.</li>
            <li><strong>Isı Yalıtım Levhaları:</strong> Zemindeki ısı kayıplarını %90 oranında azaltır.</li>
            <li><strong>Akıllı Termostatlar:</strong> Odalara özel programlanabilir sıcaklık ayarı.</li>
        </ul>
        <h4>Sistem Türleri</h4>
        <ul>
            <li><strong>Sulu (Hidronik) Sistemler:</strong>Kazan veya ısı pompası ile ısıtılan su, borularda dolaşarak ısıyı taşır. <em>Uzun ömürlü ve düşük maliyetli.</em></li>
            
            <li><strong>Elektrikli Sistemler :</strong>Elektrikli kablolar veya paspaslar ile anlık ısıtma. <em>Küçük alanlar ve hızlı montaj için ideal.</em></li>
        </ul>
        <h4>Kurulum Süreci</h4>
        <ol>
            <li><strong>Proje Tasarımı:</strong> 3D modelleme ile ısı ihtiyacı analizi</li>
            <li><strong>Zemin Hazırlığı:</strong> Isı yalıtım levhalarının döşenmesi</li>
            <li><strong>Boru Yerleştirme:</strong> Belirlenen desene göre sabitleme</li>
            <li><strong>Sistem Testi:</strong> Su veya elektrik ile basınç testi</li>
        </ol>
    </div>  

    `,
    date: "2023-05-15",
    image: "/assets/yerden-isitma-avantajlari.webp",
  },
  // Add more blog posts here
];
export const loader = async () => {
  return {
    blogPosts: blogPosts, services: HizmetListesi, references: references
  }
}
export const meta: MetaFunction = () =>
  buildMeta({
    title: "Blog | Isıtma Sistemleri Rehberi | Al-De Mühendislik",
    description:
      "Isıtma sistemleri, yerden ısıtma, kombi seçimi ve enerji verimliliği hakkında uzman rehberleri. Al-De Mühendislik blog yazılarıyla doğru ısıtma kararını verin.",
    path: "/blog",
  })
export default function Page() {
  const { blogPosts, services, references } = useLoaderData<typeof loader>();
  //blog posts sayfası
  return (
    <div className="py-20 mt-20">
      <Container className="flex-wrap">
        <h1 className="text-3xl font-bold text-center mb-12">Bizden Haberler / Blog</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {blogPosts.map((post) => (
            <a key={post.id} href={`/blog/${slugify(post?.title!)}/${post?.id}`}>
              <img src={post.image} alt={post.title} width={400} height={192} loading="lazy" className="w-full h-48 object-cover" />
              <h2 className="text-xl font-bold mt-2">{post.title}</h2>
              <p className="text-sm text-gray-500 mt-1" dangerouslySetInnerHTML={{ __html: post?.excerpt?.length > 100 ? `${post?.excerpt?.substring(0, 100)}...` : post?.excerpt }} />
            </a>
          ))}
        </div>
      </Container>
      <ServicesComponent services={services} />
      <References references={references} />
    </div>
  )
}
